"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Robot = _interopRequireDefault(require("../shapes/Robot"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var defaultNoDataText = 'There are no data to display.';

var TableNoData = function TableNoData(_ref) {
  var children = _ref.children,
      loading = _ref.loading;
  return !loading && _react["default"].createElement("div", {
    style: {
      position: 'absolute',
      left: 0,
      top: 48,
      // magic number; the height of table header
      bottom: 0,
      width: '100%',
      backgroundColor: 'white',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, _react["default"].createElement(_Robot["default"], {
    bsStyle: "warning"
  }), _react["default"].createElement("h4", null, children || defaultNoDataText));
};

TableNoData.propTypes = {
  children: _propTypes["default"].node,
  loading: _propTypes["default"].bool
};
var _default = TableNoData;
exports["default"] = _default;